<template>
  <div class="header-wrapper">
    <div class="flex items-center space-x-5">
      <div class="flex-shrink-0">
        <div v-if="podcast.image" class="relative">
          <img class="h-32 w-32 rounded-md" :src="podcast.image.image_uri" alt="podcast.name" />
        </div>
        <div v-else="podcast.image" class="relative">
          <img class="h-32 w-32 rounded-md" :src="image" alt="podcast.name" />
        </div>
      </div>
      <div>
        <h1 class="text-2xl font-bold text-white">
          {{ podcast.title }}
        </h1>
        <p class="header-subtitle" v-if="podcast.oldest_episode">
          Am
          <time :datetime="podcast.oldest_episode">
            {{ $d(new Date(podcast.oldest_episode), 'short') }}
          </time>
          auf Sendung gegangen
        </p>
        <p class="mt-2 flex items-center text-sm text-white">
          <div class="mr-4 flex items-center ">
            <MicrophoneIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-white" aria-hidden="true" />
            <span class="truncate">
              {{ podcast.num_episodes }} Folgen
            </span>
          </div>
          <div class="mr-4 flex items-center ">
            <UsersIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-white" aria-hidden="true" />
            <span class="truncate">
              {{ podcast.num_memberships }} im Team
            </span>
          </div>
          <div class="mr-4 flex items-center ">
            <BeakerIcon class="header-icon" aria-hidden="true" />
            <span class="truncate">
              {{ podcast.num_experiments }} Experimente
            </span>
          </div>
        </p>
      </div>
    </div>
    <div class="header-actions">
      <ActionButton @click="onEdit">
        <PencilSquareIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        <span class="ml-3">
          Podcast bearbeiten
        </span>
      </ActionButton>
      <!--
      <ActionButton v-if="podcast.web_uri" @click="onWebsite">
        <ArrowTopRightOnSquareIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        <span class="ml-3">
          Webseite öffnen
        </span>
      </ActionButton>
      <RefreshButton @click="onRefresh" :load="creating" v-if="rssuri">
        Aktualisieren
      </RefreshButton>
      -->
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useCreateResource } from '@/client/actions';
import { usePodcastsRouter } from '@/router/routers';

const props = defineProps({podcast: Object});
const router = usePodcastsRouter();
const store = useStore();

const image = computed(() => '/images/podcast.svg');
const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/podcasts/' + parent.value + ':refresh');
const rssuri = computed(() => Boolean(props.podcast.rss_uri));

const { create, creating } = useCreateResource(target);

const onEdit = () => router.edit();
const onWebsite = () => window.open(props.podcast.web_uri);
const onSuccess = () => store.dispatch('context/setup');
const onRefresh = () => create(onSuccess);
</script>

<style scoped>
.header-wrapper
{
  @apply max-w-3xl mx-auto;
  @apply md:flex md:items-center md:justify-between;
  @apply md:space-x-5 lg:max-w-7xl;
};

.button-link
{
  @apply inline-flex items-center justify-center px-4 py-2;
  @apply border border-gray-300;
  @apply bg-white shadow-sm rounded-md;
  @apply text-sm font-medium text-gray-700;
  @apply hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500;
  @apply focus:ring-offset-2 focus:ring-offset-gray-100;
  @apply cursor-pointer;
};

.header-subtitle
{
  @apply text-sm text-white;
  @apply font-medium;
};

.header-icon
{
  @apply flex-shrink-0;
  @apply mr-1.5 h-5 w-5;
  @apply text-white;
};

.header-actions
{
  @apply flex flex-col-reverse;
  @apply mt-6 space-y-4 space-y-reverse;
  @apply sm:flex-row-reverse sm:justify-end;
  @apply sm:space-x-reverse sm:space-y-0 sm:space-x-3;
  @apply md:mt-0 md:flex-row md:space-x-3;
};
</style>
